import { render, staticRenderFns } from "./singleCardGiveList.vue?vue&type=template&id=35451e58&scoped=true"
import script from "./singleCardGiveList.vue?vue&type=script&lang=ts"
export * from "./singleCardGiveList.vue?vue&type=script&lang=ts"
import style0 from "./singleCardGiveList.vue?vue&type=style&index=0&id=35451e58&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35451e58",
  null
  
)

export default component.exports